import {appReleaseVersion, isAppEnvDev, isAppEnvLocalDev} from "../../../config/environment";
import {logRocketAppId} from "../../../config/config";
import LogRocket from "logrocket";
import type {IProductMonitoringIdentifySessionTraits} from "../user-identify-types";
import type {IProductMonitoringTrackEventProperties} from "../event-property-types";


/**
 * get LogRocket app id for current build env
 */
const getLogRocketAppIdForEnv = (): string => {
  // if is for local dev
  if (isAppEnvLocalDev) {
    return logRocketAppId.LocalDev;
  }
  // if is for release to internal dev
  if (isAppEnvDev) {
    return logRocketAppId.ReleaseDev;
  }

  // must be production
  return logRocketAppId.ReleaseProduction;
}



class LogRocketClient {

  public initialize() {
    LogRocket.init(getLogRocketAppIdForEnv(), {
      release: `${appReleaseVersion}`,
      console: {
        // https://docs.logrocket.com/v1.0/reference#console
        // Use this option to control whether aggregated data
        // about messages logged with console.error() or LogRocket.error() is surfaced in LogRocket error reporting.
        shouldAggregateConsoleErrors: true,
      },
    });
  }

  identifySession(sessionTraits: IProductMonitoringIdentifySessionTraits): void {
    const {userId, ...sessionUserTraits} = sessionTraits;
    LogRocket.identify(`${userId}`, sessionUserTraits as unknown as Record<string, string | number | boolean>)
  }

  resetSession(): void {
    LogRocket.startNewSession();
  }

  public track(eventName: string, eventProperties?: IProductMonitoringTrackEventProperties): void {
    try {
      LogRocket.track(eventName, eventProperties);
    } catch (_e) {
      // TODO: do we want to/need to handle this?
    }
  }


  logException(exception: Error, extraData?: {[key: string]: string | number | boolean}) {
    LogRocket.captureException(exception, {extra: extraData});
  }

}


export const logRocketClient = new LogRocketClient();
